// extracted by mini-css-extract-plugin
export var video = "VideoEmbed-module--video--28m_M";
export var videoIframe = "VideoEmbed-module--videoIframe--1rGYC";
export var show = "VideoEmbed-module--show--1oBPZ";
export var showFadeInDown = "VideoEmbed-module--show-fade-in-down--1Cofy";
export var showFadeInUp = "VideoEmbed-module--show-fade-in-up--1LQ3a";
export var hideFadeOut = "VideoEmbed-module--hide-fade-out--aGI9L";